import c1 from './news/n_1.webp';
import c2 from './news/n_2.webp';
import c3 from './news/n_3.webp';
import c4 from './news/n_4.webp';
import c5 from './news/n_5.webp';
import c6 from './news/n_6.webp';
import c7 from './news/n_7.webp';
import c8 from './news/n_8.webp';
import c9 from './news/n_9.webp';
import c10 from './news/n_10.webp';
import c11 from './news/n_11.webp';
import c12 from './news/n_12.webp';
import c13 from './news/n_13.webp';
import c14 from './news/n_14.webp';
import c15 from './news/n_15.webp';
import c16 from './news/n_16.webp';
import c17 from './news/n_17.webp';
import c18 from './news/n_18.webp';
import c19 from './news/n_19.webp';
import c20 from './news/n_20.webp';
import c21 from './news/n_21.webp';
import c22 from './news/n_22.webp';
import c23 from './news/n_23.webp';
import c24 from './news/n_24.webp';
import c25 from './news/n_25.webp';
import c26 from './news/n_26.webp';
import c27 from './news/n_27.webp';
import c28 from './news/n_28.webp';
import c29 from './news/n_29.webp';
import c30 from './news/n_30.webp';
import c31 from './news/n_31.webp';
import c32 from './news/n_32.webp';
import c33 from './news/n_33.webp';
import c34 from './news/n_34.webp';
import c35 from './news/n_35.webp';
import c36 from './news/n_36.webp';
import c37 from './news/n_37.webp';
import c38 from './news/n_38.webp';
import c39 from './news/n_39.webp';
import c40 from './news/n_40.webp';

const newsImg = [
	c1,
	c2,
	c3,
	c4,
	c5,
	c6,
	c7,
	c8,
	c9,
	c10,
	c11,
	c12,
	c13,
	c14,
	c15,
	c16,
	c17,
	c18,
	c19,
	c20,
	c21,
	c22,
	c23,
	c24,
	c25,
	c26,
	c27,
	c28,
	c29,
	c30,
	c31,
	c32,
	c33,
	c34,
	c35,
	c36,
	c37,
	c38,
	c39,
	c40,
];

export default newsImg;
